<template>
  <div>
    <dl class="pt-collapsible box" role="presentation">
      <span
        v-if="eventFormat !== 'hybrid'"
        class="font-bold text-lg"
        v-text="
          $t('formation.detail.whatContent', {
            event: $t(`strapiDataMap.${eventFormat}`)
          })
        "
      />
      <span
        v-if="eventFormat === 'hybrid'"
        class="font-bold text-lg"
        v-text="$t('formation.detail.whatContentHybrid')"
      />
      <div>
        <div v-for="(item, index) in list" :key="item.id" :group-id="item.id" class="mb-4 shadow">
          <dt class="pt-collapsible__title">
            <button
              :id="`'Sesión' ${index + 1}`"
              class="flex justify-between w-full p-4 items-center"
              :aria-expanded="expandedId === item.id"
              :aria-controls="`${item.id}-content`"
              type="button"
              @click="toggleState(index)"
            >
              <div class="text-gray-dark flex">
                <WidgetsAppleCalendar v-if="item.date" class="shadow" dense :date="item.date" />
                <div class="ml-4 flex flex-col justify-start">
                  <span class="bg-blue-light w-20 text-white rounded p-1 mb-2">
                    {{ $t('formation.courses.inscription.session') }} {{ index + 1 }}
                  </span>

                  <span>{{ item.title }}</span>
                </div>
              </div>
              <icon
                class="text-blue"
                :name="expandedId === item.id ? 'pt-angle-up' : 'pt-angle-down'"
                aria-hidden="true"
              />
            </button>
          </dt>
          <dd
            :id="`${item.id}-content`"
            class="pt-collapsible__content"
            role="region"
            :class="{ 'pt-expanded': expandedId === index }"
          >
            <hr class="w-full my-4" />
            <div v-if="showSchedulers && !checkNewMaterial" class="pt-scheduler-detail">
              <ol>
                <li
                  v-for="lecture in item.lectures"
                  :key="lecture.slug"
                  class="pt-scheduler-detail__session"
                >
                  <span class="pt-scheduler-detail__session--decoration">
                    <icon name="pt-clock-three" aria-hidden="true" class="text-xl mt-1" />
                  </span>
                  <div class="pt-scheduler-detail__session--content">
                    <span class="font-bold text-sm lg:text-base text-gray-dark">
                      <span v-if="eventFormat !== 'online' && lecture.event_time">
                        {{ `${timeWithHours(lecture.event_time)} - ` }}
                      </span>
                      {{ lecture.title }}
                    </span>

                    <markdown
                      v-if="lecture.content"
                      :content="lecture.content"
                      class="pt-collapsible mt-0"
                    />
                    <div>
                      <div v-if="lecture.moderator">
                        <span class="text-sm"> {{ $t('author.moderator') }}</span>
                        <div class="pt-ponientes">
                          <Authorsevents :list="lecture.moderator" section="autor" />
                        </div>
                      </div>
                      <div v-if="lecture.speakers.length">
                        <span v-if="lecture.moderator" class="text-sm">
                          {{ $t('author.participan') }}
                        </span>
                        <div class="pt-ponientes">
                          <span v-for="speaker in lecture.speakers" :key="speaker.slug">
                            <Authorsevents :list="speaker" section="autor" />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ol>
            </div>
            <ClientOnly>
              <sessions-material
                v-if="showMaterial && checkNewMaterial && item?.lectures"
                :id="`${item.id}-content`"
                :presentations="item?.lectures"
                :video="item?.tierratv_video"
                :material="material"
                class="pt-10"
                :id-player="item.id"
              />
            </ClientOnly>
          </dd>
        </div>
      </div>
    </dl>
  </div>
</template>
<script>
import {
  dateToStringWithNameMonth,
  timeWithHours,
  timeWithMinutes,
  isSameOrBeforeDate
} from '~/utils/helpers/date';
import Authorsevents from '@/components/Authors/events';
import Markdown from '@/components/Markdown';
import SessionsMaterial from '@/components/SessionsMaterial';

export default {
  name: 'Collapsible',
  components: {
    Authorsevents,
    Markdown,
    SessionsMaterial
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
    eventFormat: {
      type: String,
      default: ''
    },
    enrolled: {
      type: Boolean,
      default: false
    },
    existMaterial: {
      type: Boolean,
      default: false
    },
    checkNewMaterial: {
      type: Boolean,
      default: false
    },
    showMaterial: {
      type: Boolean,
      default: false
    },
    material: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expandedId: undefined,
      speakersIndex: 0,
      timeWithHours,
      dateToStringWithNameMonth,
      isSameOrBeforeDate,
      timeWithMinutes,
      speakerList: []
    };
  },
  computed: {
    showSchedulers() {
      return this.existMaterial ? !this.checkNewMaterial : true;
    },
    tab() {
      return this.$store.getters['tools/getByField']('tabSectionIndex');
    }
  },
  watch: {
    tab(val) {
      this.toggleState(val);
    }
  },
  mounted() {
    if (this.list.length > 0) {
      this.expandedId = 0;
      this.joinSpeakerList();
    }
  },
  methods: {
    toggleState(id) {
      if (this.expandedId === id) {
        return [(this.expandedId = undefined), (this.speakersIndex = 0)];
      } else {
        return [(this.expandedId = id), (this.speakersIndex = id)];
      }
    },
    joinSpeakerList() {
      this.list?.forEach(element => {
        element?.lectures?.forEach(lecture => {
          lecture?.speakers?.forEach(speaker => {
            if (this.speakerList.length === 0) {
              this.speakerList.push(speaker);
            } else if (!this.speakerList.some(author => author.slug === speaker.slug))
              this.speakerList.push(speaker);
          });
        });
      });
    }
  }
};
</script>
<style src="./style.scss" lang="scss" />
